import React, {Fragment, useEffect} from "react";
import Box from "@mui/material/Box";
import {Field, reduxForm} from "redux-form";
import {getCurrentUser} from "_helpers";
import {msgSourceActions, zendeskOauthActions} from "_actions";
import {useDispatch, useSelector} from "react-redux";
import {CLIENT_URL} from "config";
import _ from "lodash";
import SubdomainInput from "../../Utilities/SubdomainInput";
import SetupModalFooter from "../../Utilities/SetupModalFooter";
import {modalInnerStyles} from "../../Utilities/basicModalStyles";

function ZendeskSetupForm({description, placeholder, channelDomain, handleClose, buttonLabel, extraInfoLabel, openInNewTab, handleSubmit, callbackUrl = `${CLIENT_URL}/signup/add-channel`, type = null}){
    const dispatch = useDispatch();
    const msgSourceLink = useSelector((state) => state.msgSources.msgSourceLink.msgSourceLink);
    const [disabled, setDisabled] = React.useState(true);

    useEffect(() => {
        dispatch(msgSourceActions.getMsgSourceLink('zendesk'));
    }, []);

    const performAction = (value) => {
        setDisabled(_.isEmpty(value));
    };

    const onSubmit = (props) => {
        const { id } = getCurrentUser();
        const params = { redirectUrl: callbackUrl, subdomain: props.subdomain, userId: id };
        if (type) {
            params.type = type;
        }
        dispatch(zendeskOauthActions.initOauth(params));
        handleClose();
    };

    return(
        <Fragment>
            <Box sx={modalInnerStyles.container}>
                <Box sx={modalInnerStyles.description}>
                    {description}
                </Box>

                <form name="zendeskEmailForm" onSubmit={ handleSubmit(onSubmit) }>
                    <Field
                        name={'subdomain'}
                        component={SubdomainInput}
                        channelDomain={channelDomain}
                        placeholder={placeholder}
                        performAction={performAction}
                    />
                    <SetupModalFooter
                        extraInfoLabel={extraInfoLabel}
                        openInNewTab={openInNewTab}
                        buttonLabel={buttonLabel}
                        disabled={disabled}
                        extraInfoLink={msgSourceLink}
                    />
                </form>
            </Box>
        </Fragment>
    )
}

const formConfig = {
    form: 'zendeskEmailForm',
};

export default reduxForm(formConfig)(ZendeskSetupForm);